<template>
  <div class="table-row-context-actions">
    <button
      type="button"
      class="table-row-context-actions__btn"
      :title="primaryLabel || undefined"
      :aria-label="primaryLabel || undefined"
      @click.stop="onPrimary"
      @mousedown.stop
      @dblclick.stop
      @contextmenu.stop.prevent
    >
      <img
        v-if="primaryIcon.kind === 'image'"
        :src="primaryIcon.url"
        alt=""
        class="table-row-context-actions__img"
      />
      <i v-else :class="primaryIcon.className" aria-hidden="true" />
    </button>
    <button
      v-if="showOverflow"
      type="button"
      class="table-row-context-actions__btn"
      :title="overflowLabel"
      :aria-label="overflowLabel"
      @click.stop="onOverflow"
      @mousedown.stop
      @dblclick.stop
      @contextmenu.stop.prevent
    >
      <i class="pi pi-ellipsis-v" aria-hidden="true" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import type { TableRowContextActionIcon } from '@/common/utils/tableRowContextActions'

defineProps<{
  primaryLabel: string
  primaryIcon: TableRowContextActionIcon
  showOverflow: boolean
  overflowLabel: string
}>()

const emit = defineEmits<{
  primary: [event: MouseEvent]
  overflow: [event: MouseEvent]
  shown: []
}>()

onMounted(() => {
  emit('shown')
})

const onPrimary = (event: MouseEvent) => {
  event.preventDefault()
  event.stopPropagation()
  emit('primary', event)
}

const onOverflow = (event: MouseEvent) => {
  event.preventDefault()
  event.stopPropagation()
  emit('overflow', event)
}
</script>

<style scoped lang="scss">
.table-row-context-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0;
}

.table-row-context-actions__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: #e8ecf0;
    color: #374151;
  }

  .pi {
    font-size: 0.8125rem;
  }
}

.table-row-context-actions__img {
  width: 0.8125rem;
  height: 0.8125rem;
  object-fit: contain;
}
</style>
